import { render, staticRenderFns } from "./MpHistoryLog.vue?vue&type=template&id=48f9e1e1&"
import script from "./MpHistoryLog.vue?vue&type=script&lang=js&"
export * from "./MpHistoryLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports